import ftr from "./ftr.jpg";


const IMGS = {
  ftr: ftr,

};

export default IMGS;
